import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({
  userAuthData: {},
});

const setUserAuthData = (state, { userAuthData }) => {
  if (!userAuthData) return false;
  return state.merge({ userAuthData });
};

const setFactoryLabelsDetail = (state, { factoryLabelsDetail }) => {
  if (!factoryLabelsDetail) return false;
  return state.merge({ factoryLabelsDetail });
};

const setActivePackageDetail = (state, { activePackageData }) => {
  if (!activePackageData) return false;
  return state.merge({ activePackageData });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_USER_AUTH_DATA,
    actionFunction: setUserAuthData,
  },
  {
    actionType: ActionTypes.SET_FACTORY_LABELS_DETAILS,
    actionFunction: setFactoryLabelsDetail,
  },
  {
    actionType: ActionTypes.SET_ACTIVE_PACKAGE,
    actionFunction: setActivePackageDetail,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
